import React from 'react';
import PropTypes from 'prop-types';
import './faq-results.scss';

const FAQResults = (props) => (
    <div className="faq-results">
        {props.resultItems.map((item, idx) => (
            <div className="faq-results__item" key={idx}>
                <div className="faq-results__question">
                    {item.question}
                </div>
                <div className="faq-results__answer">
                    {item.answer}
                </div>
            </div>
        )) }
                
        <button className="faq-results__go-back no-btn-styles" 
            onClick={props.handleGoBack}
            title="&lt; GO BACK AND MAKE NEW SELECTIONS"> 
            &lt; GO BACK AND MAKE NEW SELECTIONS
        </button>   
    </div>
);

FAQResults.propTypes = {
    resultItems: PropTypes.array.isRequired,
    handleGoBack: PropTypes.func.isRequired
}

export default FAQResults;
